/**
 * Display mode of a sheet (fiche) in the backoffice.
 * - `pro`      : full tabbed form (current/complete behaviour).
 * - `essentiel`: simplified single-page view with a curated field subset.
 *
 * Stored per-user like the field-visibility grid, under a dedicated
 * `display-mode.{formKey}` preference (same `bo_preference` system as
 * `form-fields.{formKey}`), so the choice is per sheet type (artwork,
 * sculpture, …) and syncs across devices.
 */
export type DisplayMode = "essentiel" | "pro";

/**
 * Default mode when the user has never made a choice (empty preference).
 * Kept as a single constant so switching the product-wide default is a
 * one-line change (e.g. to "essentiel" if the client requests it).
 */
export const DEFAULT_DISPLAY_MODE: DisplayMode = "pro";

/** Preference logical key holding the display mode for a given form. */
export function getDisplayModePreferenceKey(formKey: string): string {
  return `display-mode.${formKey}`;
}

/** Narrows an unknown persisted value to a valid DisplayMode. */
export function normalizeDisplayMode(value: unknown): DisplayMode {
  return value === "essentiel" || value === "pro"
    ? value
    : DEFAULT_DISPLAY_MODE;
}
